export default "__VITE_ASSET__BjMUi67C__"